import React, {Component} from "react";

export class ColumnTitle extends Component {
    renderAdditionalButton() {
        return this.props.additionalButton !== undefined ? <span style={{marginLeft:"10px"}}>{this.props.additionalButton}</span> : null;
    }

    render() {
        return (
            <div className="column-header-name">
                <p className="column-header-title d-flex align-items-center"><span>{this.props.title}</span>{this.renderAdditionalButton()}</p>
                <p className="column-header-subtitle">{this.props.subtitle}</p>
            </div>
        )
    }
}